export default "__VITE_ASSET__8f2e1f00__"